/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/Apps/Content/App/AppAction/Error"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let launcherErrorValueData = fromData.useDataValue({ viewPath,
context: 'launcher',
path: 'error',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(launcherErrorValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}